<template>
  <div class="clinics-merge-block mb-6">
    <v-btn block depressed :ripple="false" color="#f8f9fb" class="rounded-0" @click="cancelMerge" :disabled="mergeLoading">
      <v-icon size="30">icon-chevron-up</v-icon>
    </v-btn>
    <div class="pa-6">
      <v-form ref="mergeForm" v-model="formValid" class="clinics-merge-block__scroll-area">
        <div class="clinics-merge-block__row">
          <div class="clinics-merge-block__input-holder text-center"/>
          <div class="clinics-merge-block__options-row">
            <div v-for="(clinic) in mergeData" class="clinics-merge-block__option-holder text-center">
              <v-btn icon @click="deleteMergeClinic(clinic)">
                <v-icon size="25">mdi-close-thick</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
        <div class="clinics-merge-block__row">
          <div class="clinics-merge-block__input-holder text-center">
            <span class="font-weight-bold">Resultat - Klinikkens info</span>
          </div>
          <div class="clinics-merge-block__options-row">
            <div v-for="(clinic, index) in mergeData" class="clinics-merge-block__option-holder text-center">
              <v-btn color="primary" outlined @click="setOptionsValue(index)">Klik alle af</v-btn>
            </div>
          </div>
        </div>
        <div class="clinics-merge-block__row">
          <div class="clinics-merge-block__input-holder">
            <v-text-field v-model="title" label="Titel*" :rules="[rules.required]" @input="resetOptionValue('nameRow')" hide-details outlined/>
          </div>
          <ClinicsMergeOption ref="nameRow" :mergeData="mergeData" keyName="name" @changeValue="changeResultValue('title', $event)"/>
        </div>
        <div class="clinics-merge-block__row">
          <div class="clinics-merge-block__input-holder">
            <v-text-field v-model="email" label="Email*" :rules="[rules.required, rules.email]" @input="resetOptionValue('emailRow')" hide-details outlined/>
          </div>
          <ClinicsMergeOption ref="emailRow" :mergeData="mergeData" keyName="email" @changeValue="changeResultValue('email', $event)"/>
        </div>
        <div class="clinics-merge-block__row">
          <div class="clinics-merge-block__input-holder">
            <v-text-field v-model="phone" label="Telefon*" :rules="[rules.required]" @input="resetOptionValue('phoneRow')" hide-details outlined/>
          </div>
          <ClinicsMergeOption ref="phoneRow" :mergeData="mergeData" keyName="phone" @changeValue="changeResultValue('phone', $event)"/>
        </div>
        <div class="clinics-merge-block__row">
          <div class="clinics-merge-block__input-holder">
            <v-text-field v-model="mobilePhone" label="Mobil" @input="resetOptionValue('mobileRow')" hide-details outlined/>
          </div>
          <ClinicsMergeOption ref="mobileRow" :mergeData="mergeData" keyName="mobilePhone" @changeValue="changeResultValue('mobilePhone', $event)"/>
        </div>
        <div class="clinics-merge-block__row">
          <div class="clinics-merge-block__input-holder">
            <v-text-field v-model="address" label="Adresse*" :rules="[rules.required]" @input="resetOptionValue('addressRow')" hide-details outlined/>
          </div>
          <ClinicsMergeOption ref="addressRow" :mergeData="mergeData" keyName="address" @changeValue="changeResultValue('address', $event)"/>
        </div>
        <div class="clinics-merge-block__row">
          <div class="clinics-merge-block__input-holder">
            <v-text-field v-model="zip" label="Postnummer*" :rules="[rules.required]" @input="resetOptionValue('zipRow')" hide-details outlined/>
          </div>
          <ClinicsMergeOption ref="zipRow" :mergeData="mergeData" keyName="zip" @changeValue="changeResultValue('zip', $event)"/>
        </div>
        <div class="clinics-merge-block__row">
          <div class="clinics-merge-block__input-holder">
            <v-text-field v-model="city" label="By*" :rules="[rules.required]" @input="resetOptionValue('cityRow')" hide-details outlined/>
          </div>
          <ClinicsMergeOption ref="cityRow" :mergeData="mergeData" keyName="city" @changeValue="changeResultValue('city', $event)"/>
        </div>
        <div class="clinics-merge-block__row">
          <div class="clinics-merge-block__input-holder">
            <v-select :items="statusItems" :rules="[rules.requiredId]" item-text="value" item-value="key" label="Status*" v-model="status" @change="resetOptionValue('statusRow')" hide-details outlined/>
          </div>
          <ClinicsMergeOption ref="statusRow" :mergeData="mergeData" keyName="status" @changeValue="changeResultValue('status', $event)"/>
        </div>
        <div class="clinics-merge-block__row">
          <div class="clinics-merge-block__input-holder text-center">Henvisere/brugere</div>
          <ClinicsMergeOption :mergeData="mergeData" keyName="members"/>
        </div>
      </v-form>
      <div class="d-flex justify-center my-10 px-lg-12">
        <p class="mb-0">"Fusioneringen" af brugerne kan ikke fortrydes. Alle medlemmer af den enkelte klinik vil blive slået sammen til een klinik. Hvis brugeren havde en sekretærrolle i den tidligere klinik, vil denne blive bibeholdt i den nye klinik. Alle henvisninger vil tilhøre den originale henviser/tandlæge. Tandlægerne kan have flere profiler, men de er unikke, så de vil blive ved med at være seperate.</p>
      </div>
      <div class="d-flex justify-center mt-6">
        <v-btn color="primary" @click="saveMerge" :loading="mergeLoading" :disabled="mergeLoading">Gem "fusioneringen"</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import ClinicsMergeOption from './ClinicsMergeOption.vue';
  import validationRules from '../../utils/validationRules';
  import api from '../../api/api';

  export default {
    name: 'ClinicsMergeDialog',

    components: {ClinicsMergeOption},

    props: {
      mergeData: {
        type: Array,
      },
      filterParams: {
        type: Object
      },
      queryParams: {
        type: Object
      }
    },

    data: function() {
      return {
        rules: {...validationRules},
        formValid: false,
        mergeDialog: false,
        mergeLoading: false,
        title: '',
        address: '',
        zip: '',
        city: '',
        status: null,
        email: '',
        phone: '',
        mobilePhone: '',
      }
    },

    computed: {
      statusItems: function() {
        return this.$store.state.clinicsStore.statusItems;
      }
    },

    watch: {
      mergeData: function() {
        this.resetData();
        this.setOptionsValue(null);
        this.$refs.mergeForm.reset();
      }
    },

    methods: {
      changeResultValue: function(key, value) {
        this[key] = value;
      },
      deleteMergeClinic: function(clinic) {
        this.$emit('deleteMergeClinic', clinic);
      },
      resetData: function() {
        this.title = '';
        this.address = '';
        this.zip = '';
        this.city = '';
        this.status = null;
        this.email = '';
        this.phone = '';
        this.title = '';
        this.mobilePhone = '';
      },
      setOptionsValue: function(value) {
        this.$refs.nameRow.setValue(value);
        this.$refs.emailRow.setValue(value);
        this.$refs.phoneRow.setValue(value);
        this.$refs.mobileRow.setValue(value);
        this.$refs.addressRow.setValue(value);
        this.$refs.zipRow.setValue(value);
        this.$refs.cityRow.setValue(value);
        this.$refs.statusRow.setValue(value);
      },
      resetOptionValue: function(ref) {
        this.$refs[ref].setValue(null);
      },
      cancelMerge: function() {
        this.resetData();
        this.$emit('closeMergeDialog');
      },
      saveMerge: async function() {
        this.$refs.mergeForm.validate();
        if (!this.formValid) return;
        let queryBody = {};
        queryBody.name = this.title;
        queryBody.address = this.address;
        queryBody.zip = this.zip;
        queryBody.city = this.city;
        queryBody.phone = this.phone;
        queryBody.email = this.email;
        queryBody.status = this.status;
        queryBody.mobilePhone = this.mobilePhone;
        queryBody.clinicIdsToMerge = [];
        this.mergeData.forEach((item) => {
          queryBody.clinicIdsToMerge.push(item.clinicId);
        });
        try {
          this.mergeLoading = true;
          await api.mergeClinics(queryBody);
          let newClinicsData = await api.getClinics({...this.queryParams, ...this.filterParams});
          this.mergeLoading = false;
          this.$emit('updateClinicsData', newClinicsData.data);
          this.$emit('clearMerge');
          this.$emit('closeMergeDialog');
          this.$emit('moveToControls');
        } catch (e) {
          this.mergeLoading = false;
        }
      }
    }
  };
</script>

